import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
import { CHECKOUT_URL } from './Shared';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 14,
    s: 16
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = current.h * 3600 + current.m * 60 + current.s;
        if (seconds <= 0) return current;
        const next = seconds - 1;
        return {
          h: Math.floor(next / 3600),
          m: Math.floor(next % 3600 / 60),
          s: next % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const formattedTime = `${String(timeLeft.h).padStart(2, '0')}:${String(timeLeft.m).padStart(2, '0')}:${String(timeLeft.s).padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/50 bg-brand-ink text-brand-paper shadow-md" data-id="element-317" data-mp="1bwgcd6b9rhxu">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-3 py-2 text-[11px] font-medium sm:gap-5 md:px-6 md:py-2.5 md:text-sm" data-id="element-318" data-mp="1guhv1q4s9f8s">
        <div className="flex items-center gap-1.5 whitespace-nowrap text-brand-goldLight" data-id="element-319" data-mp="22nq32lfvouks">
          <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-320" data-mp="1xodjc9kb03mf">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-burgundy opacity-75" data-id="element-321" data-mp="1xmkd2vdlrley" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-burgundy" data-id="element-322" data-mp="2qe3ymlxo9bk4" />
          </span>
          <strong className="uppercase tracking-[0.14em]" data-id="element-323" data-mp="2le7u8ll2bi41">
            Oferta de lanzamiento
          </strong>
        </div>
        <span className="h-4 w-px bg-brand-gold/45" aria-hidden="true" data-id="element-324" data-mp="2ge39gjd4g180" />
        <div className="flex items-center gap-1.5 whitespace-nowrap text-brand-paper" data-id="element-325" data-mp="2cekr9vcoq48v">
          <ClockIcon className="h-3.5 w-3.5 text-brand-goldLight" aria-hidden="true" data-id="element-326" data-mp="14zzgngi9sj4j" />
          <span className="hidden sm:inline" data-id="element-327" data-mp="10xl0x59wdzhh">Finaliza en</span>
          <span className="font-mono font-bold tabular-nums text-brand-goldLight" data-id="element-328" data-mp="12ftf1fh4p4r5">
            {formattedTime}
          </span>
        </div>
        <a href={CHECKOUT_URL} className="rounded-sm border border-brand-goldLight/60 bg-brand-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-brand-ink transition-colors hover:bg-brand-goldLight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-paper sm:px-3 sm:text-xs" data-id="element-329" data-mp="17duyw2mdp83o">
          Ver pack →
        </a>
      </div>
    </div>;
}